import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialValues = {
  cart: {},
  items: [],
  totals: [],
  shippingAddress: null,
  showShippingMethods: false,
  showPayments: false,
  shippingMethods: [],
  activeShippingMethod: null,
  pickupStore: {},
  mainUserAddress: {},
  userAddresses: [],
  payments: null,
  regions: [],
  mobiles: {},
  tel: null,
  mapLocation: null,
};

const useCheckout = create(
  persist(
    (set) => ({
      ...initialValues,
      isHydrated: false,
      setHydrated: (state) => set({ isHydrated: state }),
      setCart: (cart) =>
        set(() => ({
          cart,
          items: cart?.items || [],
          totals: cart?.total_segments || [],
        })),

      setShippingAddress: (shippingAddress) => set(() => ({ shippingAddress })),

      setMapLocation: (mapLocation) => set(() => ({ mapLocation })),

      setShowShippingMethods: (showShippingMethods) =>
        set(() => ({ showShippingMethods })),

      setShowPayments: (showPayments) => set(() => ({ showPayments })),

      setShippingMethods: (shippingMethods) => set(() => ({ shippingMethods })),

      setActiveShippingMethod: (activeShippingMethod) =>
        set(() => ({ activeShippingMethod })),

      setPickupStore: (pickupStore) => set(() => ({ pickupStore })),

      setPayments: (payments) => {
        return set(() => ({ payments }));
      },

      setRegions: (regions) => set(() => ({ regions })),

      setUserAddresses: (userAddresses) => set(() => ({ userAddresses })),

      setMainUserAddress: (mainUserAddress) => set(() => ({ mainUserAddress })),

      setTel: (tel) => set(() => ({ tel })),

      removeItem: (itemId) =>
        set((state) => {
          // Remove the item from the cart
          const updatedCartItems = state.cart?.items?.filter(
            (item) => item.item_id !== itemId
          );
          return {
            ...state,
            cart: { ...state?.cart, items: updatedCartItems },
          };
        }),

      setMobiles: ({ mobile, status }) =>
        set((state) => ({
          mobiles: { ...state.mobiles, [mobile]: status },
        })),

      clearCheckout: () => set(initialValues),
    }),
    {
      name: 'checkout',
      onRehydrateStorage: () => (state) => {
        state.setHydrated(true);
      },
    }
  )
);

export default useCheckout;
